import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-0 left-0 z-[100]! flex flex-nowrap items-end gap-16 justify-center w-full md:hidden bg-[linear-gradient(0deg,rgba(0,0,0,1)0%,rgba(0,0,0,0.66)52%,rgba(0,0,0,0)100%)]"
}
const _hoisted_2 = {
  key: 1,
  class: "fixed bottom-0 left-0 z-[100]! grid grid-cols-5 items-end justify-center w-full md:hidden bg-[linear-gradient(0deg,rgba(0,0,0,1)0%,rgba(0,0,0,0.66)52%,rgba(0,0,0,0)100%)]"
}

export function render(_ctx, _cache) {
  return (!_ctx.checkPaths() || !_ctx.auth.isLoggedIn)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (!_ctx.auth.isLoggedIn)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.btnClickRegister && _ctx.btnClickRegister(...args))),
              class: "cursor-pointer",
              title: "register"
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("img", {
                class: "w-full",
                src: "https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-mb-register.webp",
                alt: "register"
              }, null, -1 /* HOISTED */)
            ])))
          : (_openBlock(), _createElementBlock("li", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.btnClickProfile && _ctx.btnClickProfile(...args))),
              class: "cursor-pointer",
              title: "register"
            }, _cache[10] || (_cache[10] = [
              _createElementVNode("img", {
                class: "w-full",
                src: "https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-mb-profile.webp",
                alt: "profile"
              }, null, -1 /* HOISTED */)
            ]))),
        _createElementVNode("li", {
          onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.btnClickGame && _ctx.btnClickGame(...args))),
          class: "cursor-pointer absolute -bottom-3",
          title: "play"
        }, _cache[11] || (_cache[11] = [
          _createElementVNode("img", {
            class: "max-w-32",
            src: "https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-mb-play-new.webp",
            alt: "play"
          }, null, -1 /* HOISTED */)
        ])),
        _createElementVNode("li", {
          onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.btnClickContact && _ctx.btnClickContact(...args))),
          class: "cursor-pointer",
          title: "support"
        }, _cache[12] || (_cache[12] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-mb-contact.webp",
            alt: "support"
          }, null, -1 /* HOISTED */)
        ]))
      ]))
    : (_openBlock(), _createElementBlock("ul", _hoisted_2, [
        _createElementVNode("li", {
          onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.btnClickProfile && _ctx.btnClickProfile(...args))),
          class: "cursor-pointer",
          title: "โปรไฟล์"
        }, _cache[13] || (_cache[13] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://rpg168.sgp1.cdn.digitaloceanspaces.com/theme/ft-btn-1.webp",
            alt: "โปรไฟล์"
          }, null, -1 /* HOISTED */)
        ])),
        _createElementVNode("li", {
          onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.btnClickWallet && _ctx.btnClickWallet(...args))),
          class: "cursor-pointer",
          title: "กระเป๋าตัง"
        }, _cache[14] || (_cache[14] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://rpg168.sgp1.cdn.digitaloceanspaces.com/theme/ft-btn-2.webp",
            alt: "กระเป๋าตัง"
          }, null, -1 /* HOISTED */)
        ])),
        _createElementVNode("li", {
          onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.btnClickPromotion && _ctx.btnClickPromotion(...args))),
          class: "cursor-pointer",
          title: "โปรโมชั่น"
        }, _cache[15] || (_cache[15] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://rpg168.sgp1.cdn.digitaloceanspaces.com/theme/ft-btn-3.webp",
            alt: "โปรโมชั่น"
          }, null, -1 /* HOISTED */)
        ])),
        _createElementVNode("li", {
          onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.btnClickAffiliate && _ctx.btnClickAffiliate(...args))),
          class: "cursor-pointer",
          title: "แนะนำเพื่อน"
        }, _cache[16] || (_cache[16] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://rpg168.sgp1.cdn.digitaloceanspaces.com/theme/ft-btn-4.webp",
            alt: "แนะนำเพื่อน"
          }, null, -1 /* HOISTED */)
        ])),
        _createElementVNode("li", {
          onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.btnClickContact && _ctx.btnClickContact(...args))),
          class: "cursor-pointer",
          title: "ติดต่อ"
        }, _cache[17] || (_cache[17] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://rpg168.sgp1.cdn.digitaloceanspaces.com/theme/ft-btn-5.webp",
            alt: "ติดต่อ"
          }, null, -1 /* HOISTED */)
        ]))
      ]))
}